import { Card } from "../../../../Card/Card";

import styles from "./Skeleton.module.scss";

export const Skeleton = () => (
  <Card data-testid="skeleton">
    <div className={styles.title} />
    <div className={styles.subtitle} />
    <Card.Separator />
    <div className={styles.productName} />
    <Card.Separator />
    <div className={styles.frequency} />
    <div className={styles.button} />
  </Card>
);
